// The one-step profile form of core.md §4.3 — its fields, its rules, its states.
export const onboarding = {
  // ── onboarding — core.md §4.3 ────────────────────────────────────────
  'onboarding.title': 'خوش آمدید — خودتان را معرفی کنید',
  'onboarding.sub': 'یک فرم کوتاه. همه‌اش را بعداً در پروفایل می‌توانید تغییر دهید.',
  'onboarding.fields.fullName': 'نام و نام خانوادگی',
  'onboarding.fields.studentNumber': 'شماره دانشجویی',
  'onboarding.fields.studentNumberHelper': 'شمارهٔ دانشجویی دانشگاه شما — نه کد نظام پزشکی. بررسی نمی‌شود.',
  'onboarding.fields.university': 'دانشگاه',
  'onboarding.fields.universityHelper': 'از فهرست انتخاب کنید یا خودتان بنویسید.',
  'onboarding.fields.level': 'مقطع',
  'onboarding.fields.field': 'رشته',
  'onboarding.fields.fieldHelper': 'رشتهٔ دستیاری، مثلاً داخلی.',
  'onboarding.fields.entryYear': 'سال ورود (شمسی)',
  'onboarding.fields.bio': 'معرفی کوتاه',
  'onboarding.fields.phone': 'شمارهٔ موبایل',
  'onboarding.fields.phoneHelper': 'از حساب ورود شما خوانده می‌شود و از همان‌جا تغییر می‌کند.',
  'onboarding.level.student': 'دانشجوی پزشکی',
  'onboarding.level.intern': 'کارورز',
  'onboarding.level.resident': 'دستیار تخصصی',
  'onboarding.submit': 'شروع',
  'onboarding.saving': 'در حال ذخیرهٔ پروفایل…',
  'onboarding.done': 'آماده است — در حال باز کردن بیماران…',
  'onboarding.validation.fullName': 'نام خود را وارد کنید (۲ تا ۱۲۰ نویسه).',
  'onboarding.validation.studentNumber': '۴ تا ۲۰ حرف، رقم یا خط تیره وارد کنید.',
  'onboarding.validation.university': 'دانشگاه خود را وارد کنید (۲ تا ۱۲۰ نویسه).',
  'onboarding.validation.level': 'مقطع خود را انتخاب کنید.',
  'onboarding.validation.field': 'حداکثر ۸۰ نویسه.',
  'onboarding.validation.entryYear': 'یک سال شمسی بین ۱۳۷۰ و ۱۴۲۰.',
  'onboarding.validation.bio': 'حداکثر ۵۰۰ نویسه.',
  'onboarding.error.unavailable': 'فعلاً ذخیره نشد. پاسخ‌های شما نگه داشته شده‌اند؛ دوباره تلاش کنید.',
  // A FAILED status query is rendered by App.jsx's boot gate (`auth.bootFailed.*`),
  // never by the onboarding screen: the form is shown because the status said
  // `isOnboarded: false`, and for no other reason (core.md §4.3).
};

export default onboarding;
